import { Link } from 'react-router-dom';

import { fetchSiteProfile } from '../api/client';
import { useApi } from '../hooks/useApi';
import { useT } from '../i18n/LanguageProvider';
import Brand from './Brand';

export default function SiteFooter() {
  const profile = useApi('site-profile', fetchSiteProfile);
  const t = useT();

  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <Brand />
          <p className="footer-intro">{t.footer.intro}</p>
        </div>
        <div>
          <h4>{t.footer.pages}</h4>
          <ul>
            <li>
              <Link to="/tjanster">{t.nav.services}</Link>
            </li>
            <li>
              <Link to="/case">{t.nav.cases}</Link>
            </li>
            <li>
              <Link to="/insights">{t.nav.insights}</Link>
            </li>
            <li>
              <Link to="/om-oss">{t.nav.about}</Link>
            </li>
            <li>
              <Link to="/kontakt">{t.nav.contact}</Link>
            </li>
          </ul>
        </div>
        <div>
          <h4>{t.footer.contact}</h4>
          <ul>
            {profile.status === 'ready' && (
              <li>
                <a href={`mailto:${profile.data.email}`}>{profile.data.email}</a>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} NorthBridge One AB</span>
        <span>{t.footer.tagline}</span>
      </div>
    </footer>
  );
}
